<template>
<div id="top-container" class="container">
	<div class="row align-items-center info-row">
		<div class="col-12 col-md-8 pf-text">
			<h1 class="pf-title">Arthur K. Zhang</h1>
			I am currently a Computer Science PhD Student at UT Austin. I work on developing robots that can react, reason, and continuously adapt to new environments and tasks. My research expertise spans <b>3D perception, foundation model post-training for robotics, and alignment with human preferences</b>. I am advised by <a class="link" href="https://www.joydeepb.com" target="_blank">Joydeep Biswas</a>, director of the Autonomous Mobile Robotics Laboratory. During my undergrad at the UM Ann Arbor <b>(Go Blue!)</b>, I worked with <a class="link" href="https://curly.engin.umich.edu/curly" target="_blank">Maani Ghaffari</a> on 3D semantic mapping. I have been fortunate to receive recognition from the NSF Graduate Research Fellowship Program and spent summers working on self-driving at <a class="link" href="https://www.nvidia.com" target="_blank">NVIDIA</a> and foundation model post-training at <a class="link" href="https://www.fieldai.com" target="_blank">FieldAI</a>. 
			<contact/>
		</div>
		<div class="col-12 col-md-4 text-center">
			<img class="pf-img img-fluid" src="../assets/profile.jpg" alt="Arthur Zhang">
		</div>
	</div>
	<hr class="section-divider">
	<!-- <div class="honors-section">
		<div class="section-heading">News</div>
		<ul class="honors-list">
			<li v-for="(honor, i) in honors" :key="i">
				<span class="honor-year">{{ honor.year }}</span>
				<span class="honor-text" v-html="honor.text"></span>
			</li>
		</ul>
	</div> -->
	<!-- <hr class="section-divider"> -->
	<projects/>
</div>
</template>
<script>
import Contact from "./Contact"
import Projects from './Projects'
import VueAnchorRouterLink from 'vue-anchor-router-link'
import NavBar from './NavBar'

export default {
	name: 'About',
	components: {
		'nav-bar': NavBar,
		'anchor-router-link': VueAnchorRouterLink,
		'projects': Projects,
		'contact': Contact
	},
	data() {
		return {
			navMsg: 'Resourceful Learner | Passionate Engineer | Easygoing Friend',
			honors: [
				{ year: '2026', text: 'UT Austin Calhoun Graduate Fellowship' },
				{ year: '2025', text: 'UT Austin Calhoun Graduate Fellowship' },
				{ year: '2024', text: 'NSF Graduate Research Fellowship Honorable Mention' },
				
			]
		}
	}
};
</script>
<style scoped>
h1 {
	font-weight: normal;
}

#top-container {
	max-width: 960px;
	padding-top: 20px;
	text-align: left;
}

.info-row {
	margin-bottom: 4px;
}

.pf-text {
	text-align: left;
	font-size: 15px;
	line-height: 1.6;
	color: #333;
}

.pf-title {
	margin: 0 0 6px;
	text-align: left;
	font-size: 32px;
	font-weight: bold;
}

.pf-img {
	max-width: 250px;
	object-fit: contain;
}

.section-divider {
	border: 0;
	border-top: 1px solid #ddd;
	margin: 14px 0;
}

.section-heading {
	font-size: 28px;
	font-weight: 600;
	margin-bottom: 10px;
}

.honors-list {
	list-style: none;
	padding: 0;
	margin: 0;
	font-size: 15px;
	line-height: 1.6;
	color: #333;
}

.honors-list li {
	display: flex;
	margin-bottom: 4px;
}

.honor-year {
	flex: 0 0 70px;
	font-weight: bold;
}

.link {
	color: #3399ff;
	text-decoration: none;
}

.link:hover {
	text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/About.vue